import { useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus, RuleElement } from '@wix/rules-panel-ui';
import React, { useCallback } from 'react';
import { BiCtaNames } from '../../../bi/types';
import { useBiLogger } from '../../../hooks/use-bi-logger';
import { useHandleElementClick } from '../../../hooks/use-handle-element-click';
import { convertBooleanStatusToElementStatus } from '../alt-image-fixer/utils';
import { InaccessibleLayoutElementContent } from './inaccessible-layout-rule-content/inaccessible-layout-element-content';
import { InaccessibleLayoutRuleHeader } from './inaccessible-layout-rule-header';
import { getCurrentLayoutName } from './utils/layout-utils';
export const InaccessibleLayoutRule = _ref => {
  let {
    isOpen,
    toggleElement,
    elementIndex,
    element,
    contentRef,
    headerRef,
    pageId
  } = _ref;
  const biLogger = useBiLogger();
  const {
    t
  } = useTranslation();
  const status = convertBooleanStatusToElementStatus(element.isFixed ?? false);
  const onStatusChange = useCallback(() => {
    biLogger.elementStatusChange({
      index: elementIndex,
      status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
    });
  }, [biLogger, elementIndex, status]);
  const {
    handleClickElement
  } = useHandleElementClick({
    isOpen,
    onOpenElement: () => biLogger.taskElementCtaClick({
      ctaName: BiCtaNames.Edit,
      index: elementIndex,
      status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
    }),
    toggleElement
  });
  return /*#__PURE__*/React.createElement(RuleElement, {
    contentComponent: /*#__PURE__*/React.createElement("div", {
      ref: contentRef
    }, /*#__PURE__*/React.createElement(InaccessibleLayoutElementContent, {
      element: element,
      elementIndex: elementIndex,
      pageId: pageId,
      status: status
    })),
    headerComponent: /*#__PURE__*/React.createElement("div", {
      ref: isOpen ? headerRef : null
    }, /*#__PURE__*/React.createElement(InaccessibleLayoutRuleHeader, {
      label: getCurrentLayoutName(element.widgetId, element.layoutValue)
    })),
    iconButtonAriaLabel: t('accessibility-wizard.common.edit.aria-label'),
    iconButtonToolTip: t('accessibility-wizard.common.edit'),
    id: element.id,
    isOpen: isOpen,
    status: status,
    onClick: handleClickElement,
    onStatusChange: onStatusChange
  });
};
//# sourceMappingURL=inaccessible-layout-rule.js.map